export default "__VITE_ASSET__Dpyq0ucU__"